var _rect, _rect2, _rect3, _path, _rect4, _rect5, _path2, _rect6, _rect7, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExportIcon = function SvgExportIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 80,
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    fill: "#EDEDED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    stroke: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29C17.7938 29 16 30.7938 16 33V57C16 59.2062 17.7938 61 20 61H36C38.2062 61 40 59.2062 40 57V39H32C30.8938 39 30 38.1062 30 37V29H20ZM32 29V37H40L32 29ZM20 43H21.5C23.4313 43 25 44.5688 25 46.5C25 48.4312 23.4313 50 21.5 50H21V52C21 52.55 20.55 53 20 53C19.45 53 19 52.55 19 52V49V44C19 43.45 19.45 43 20 43ZM21.5 48C22.3313 48 23 47.3312 23 46.5C23 45.6688 22.3313 45 21.5 45H21V48H21.5ZM26 44C26 43.45 26.45 43 27 43H28.5C30.1562 43 31.5 44.3438 31.5 46V50C31.5 51.6562 30.1562 53 28.5 53H27C26.45 53 26 52.55 26 52V44ZM28 51H28.5C29.05 51 29.5 50.55 29.5 50V46C29.5 45.45 29.05 45 28.5 45H28V51ZM34 43H37C37.55 43 38 43.45 38 44C38 44.55 37.55 45 37 45H35V47H37C37.55 47 38 47.45 38 48C38 48.55 37.55 49 37 49H35V52C35 52.55 34.55 53 34 53C33.45 53 33 52.55 33 52V48V44C33 43.45 33.45 43 34 43Z",
    fill: "#6F6F6F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 14.5,
    width: 41,
    height: 41,
    rx: 8.5,
    fill: "#EDEDED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 14.5,
    width: 41,
    height: 41,
    rx: 8.5,
    stroke: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5001 26.5C71.8432 26.5 70.5001 27.8431 70.5001 29.5C70.5001 31.1569 71.8432 32.5 73.5001 32.5C75.157 32.5 76.5001 31.1569 76.5001 29.5C76.5001 27.8431 75.1563 26.5 73.5001 26.5ZM91.9438 21H67.9438C65.7907 21 63.9995 22.7906 63.9995 25V45C63.9995 47.2094 65.7901 49 67.9433 49H91.9433C94.1526 49 95.9433 47.2094 95.9433 45V25C95.9438 22.7906 94.2063 21 91.9438 21ZM92.9438 44.5812L84.3938 32.9625C84.2376 32.675 83.8813 32.5 83.5001 32.5C83.118 32.5 82.7613 32.673 82.5495 32.9612L75.887 41.9674L73.5688 39.0862C73.3538 38.8188 73.0105 38.6606 72.6457 38.6606C72.2806 38.6606 71.9376 38.8187 71.722 39.0862L67.002 44.9493C67.002 44.9475 67.002 44.9511 67.002 44.9493L66.9995 25C66.9995 24.4486 67.4481 24 67.9995 24H91.9995C92.5508 24 92.9995 24.4486 92.9995 25V44.5812H92.9438Z",
    fill: "#6F6F6F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    fill: "#EDEDED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 24.5,
    width: 41,
    height: 41,
    rx: 8.5,
    stroke: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119 33C117.344 33 116 34.3438 116 36C116 36.9437 116.444 37.8312 117.2 38.4L130.8 48.6C131.512 49.1313 132.488 49.1313 133.2 48.6L146.8 38.4C147.556 37.8312 148 36.9437 148 36C148 34.3438 146.656 33 145 33H119ZM116 40V53C116 55.2062 117.794 57 120 57H144C146.206 57 148 55.2062 148 53V40L134.4 50.2C132.975 51.2688 131.025 51.2688 129.6 50.2L116 40Z",
    fill: "#6F6F6F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExportIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/export-icon.5a197037eef752585e9608f8db56e2a8.svg";